// Auto-generated file, scripts/set-version.js will update this file during build
export const version = '21.0.25';
export const gitHash = '65ff4e149';
export const buildTime = '2026-11-03T00:01:48.162Z';
